import React, { useState, useEffect } from 'react';
import { Div, RowDiv, Section, Text } from 'styles';
import { Button, Icon, Img, Input, LineText, Modal, Radio, SubTitle, Switch } from 'components';
import { useImmer } from 'use-immer';
import { Spinner } from 'components/loading/Spinner';
import { findIndex } from 'lodash';
import ModalActuatorConAirDetail from 'components/dialogs/con-control/modal-conactuator-chillandac-detail';
import conActuatorService from 'services/container/container-actuator-service';
import * as S from './ConControlStyle';


export function ConControl(props) {
  const [modalOpen, setModalOpen] = useState();
  const [selectedRadio, setSelectedRadio] = useState('use');
  const [values, setValues] = useState({ type: '1', val1: '' });

  const [actuatorData, updateActuatorData] = useImmer({
    apiCallIndex: 0,
    actuators: [
      { id: 'airconditioner_1', label: 'Airconditioner_1', type: 'Aircon', sensorValue: null, loading: true},
      { id: 'chiller_1', label: 'chiller_1', type: 'Aircon', sensorValue: null, loading: true},
    ]
  });

  const [detailModalData, updateDetailModalData] = useImmer({
    type: null,
    open: false,
    id: null,
    sensorValue: null,
    title: '',
    data: null
  })

  const getAcAndChillData = async (id) => {
    const actuatorIndex = findIndex(actuatorData.actuators, (a) => a.id === id)

    if (actuatorIndex < 0) {
      return
    }

    let data = null;

    updateActuatorData((draft) => {
      draft.actuators[actuatorIndex].sensorValue = null;
      draft.actuators[actuatorIndex].loading = true;
    })

    try {
      data = await conActuatorService.getContainerActuatorDetail(id);
    } catch (e) {
      console.error(e);
    }

    if (data !== null) {
      updateActuatorData((draft) => {
        draft.actuators[actuatorIndex].sensorValue = data.length > 0 ? data[0].sensor_value : null;
        draft.actuators[actuatorIndex].loading = false;
      })
    }
  }
  useEffect(() => {
    actuatorData.actuators.forEach((actuator) => {
      getAcAndChillData(actuator.id);
    })
  }, [actuatorData.apiCallIndex])

  // const onChange = (name, val) => {
  //   setValues((prev) => ({ ...prev, [name]: val }));
  // };

  // const radioOnChange = (val) => {
  //   setSelectedRadio(val);
  // };

  // const cancel = () => {
  //   setValues({ type: '1', val1: '' });
  //   setModalOpen();
  //   setSelectedRadio('use');
  // };

  // const submit = () => {
  //   // alert('submit');
  //   setModalOpen();
  //   setSelectedRadio('use');
  // };

  return (
    <>
      <Section>
        <SubTitle title="제어 시스템" sub="Actuator" desc="전체 제어 상태" />
        <S.InfoDiv>
          <Icon name="Light" />
          <Text $type="m14" $color="supportive">
            장비 아이콘을 클릭하여 상세 제어 요소를 설정할 수 있습니다.
          </Text>
        </S.InfoDiv>
        <S.ControlList>
          {
            actuatorData.actuators.map((actuator) => (
              <li key={actuator.id}>
                {/* <S.HoverDiv onClick={() => setModalOpen('Airconditioner')}> */}
                <S.HoverDiv 
                  onClick={async () => {  // 'async' 키워드를 추가하여 비동기 함수로 선언
                    let Data = null;
                    try {
                      // actuator.id에 따라 분기 처리
                      switch (actuator.id) {
                        case 'airconditioner_1': // 에어컨 3에 대한 데이터 처리
                        Data = await conActuatorService.getAirconditionData(actuator.id);
                          break;

                        case 'chiller_1': // 칠러 1에 대한 데이터 처리
                        Data = await conActuatorService.getChillerData(actuator.id);
                          break;

                        default: // 기타 액추에이터 처리
                          console.warn(`Unhandled actuator id: ${actuator.id}`);
                          Data = null;
                      }

                    } catch (e) {
                      console.error('에어컨 데이터 가져오기 실패:', e);
                    }
                        
                    // 상태 업데이트 (모달 열기)
                    updateDetailModalData((draft) => {
                      draft.id = actuator.id;
                      draft.type = actuator.type;
                      draft.open = true;
                      draft.title = actuator.label;
                      draft.data = Data;
                    });
                  }}
                >
                  <Icon name={actuator.type} />
                  <S.ConDiv>
                    <Text $type="m18">{actuator.label}</Text>
                    { actuator.loading ?
                      <Spinner $width={20} $height={20}/>
                      :
                      <>
                        { actuator.type !== 'Window' &&
                          <Button $size="control" $type="control">
                            {actuator.sensorValue > 0 ? 'ON' : 'OFF'}
                          </Button>
                        }
                        {/* { actuator.type === 'Window' &&
                          <Button $size="control" $type="control">
                            {actuator.sensorValue === 1 ? '열림' : '닫힘'}
                          </Button>
                        } */}
                      </>
                    }
                  </S.ConDiv>
                  {/* <Icon name="Aircon" />
                  <S.ConDiv>
                    <Text>Airconditioner</Text>
                    <Button $size="control" $type="control">
                      ON
                    </Button>
                  </S.ConDiv>
                </S.HoverDiv>
              </li>
              <li>
                <S.HoverDiv onClick={() => setModalOpen('Chiller')}>
                  <Icon name="Scuttle" />
                  <S.ConDiv>
                    <Text>Chiller</Text>
                    <Button $size="control" $type="control">
                      ON
                    </Button>
                  </S.ConDiv>
                </S.HoverDiv>
              </li> */}
              </S.HoverDiv>
              </li>
            ))
          }
        </S.ControlList>
        <LineText $margin="32px 0 12px">센서위치 확인</LineText>
        <Div $minHeight={552}>
          <Img src="ContainerControl" $objectFit="cover" $width="100%" />
        </Div>
      </Section>
      {/* {modalOpen && (
        <Modal open={modalOpen} title={modalOpen} cancel={cancel} submit={submit}>
          <Radio
            name="controlOption"
            value="use"
            checked={selectedRadio === 'use'}
            onChange={radioOnChange}
            $marginBottom={24}
            $height={30}
            $alignItems="center"
          >
            <RowDiv $justifyContent="space-between" $alignItems="center" $flex={1}>
              <Text>사용여부</Text>
              <Switch
                name="val1"
                filters={values}
                onChange={onChange}
                $line
                list={[
                  { name: 'ON', val: '1' },
                  { name: 'OFF', val: '2' },
                ]}
                disabled={selectedRadio !== 'use'}
              />
            </RowDiv>
          </Radio>
          <Radio
            name="controlOption"
            value="control"
            checked={selectedRadio === 'control'}
            onChange={radioOnChange}
            $alignItems="flex-start"
          >
            <Input
              $default
              label="장비제어조건"
              subLabel="온도 설정"
              name={modalOpen}
              value={values[`${modalOpen}`] || ''}
              onChange={onChange}
              placeholder="온도값 입력"
              unit="℃"
              $flex={1}
              disabled={selectedRadio !== 'control'}
            />
          </Radio>
        </Modal>
      )} */}

      { detailModalData.open && detailModalData.type === 'Aircon' &&
        <ModalActuatorConAirDetail id={detailModalData.id} sensorValue={detailModalData.sensorValue} title={detailModalData.title} open={detailModalData.open} data={detailModalData.data} setOpen={(open) => {
          updateDetailModalData((draft) => {
            draft.open = open;
          })
        }} afterCancel={() => {

        }} afterSubmit={() => {
          getAcAndChillData(detailModalData.id);
        }}/>
      }
    </>
  );
}
